import { z } from 'zod';

enum MessageErrors {
    Invalid = 'O valor do campo é inválido.',
    Required = 'O campo é obrigatório.',
}

export const commissionsSchema = z.array(
    z.object({
        administradora: z.string({
            required_error: MessageErrors.Required,
            invalid_type_error: MessageErrors.Invalid,
        }),
        xpCode: z.union([
            z.number({
                required_error: MessageErrors.Required,
                invalid_type_error: MessageErrors.Invalid,
            }),
            z.string({
                required_error: MessageErrors.Required,
                invalid_type_error: MessageErrors.Invalid,
            }),
        ]),
        contrato: z.union([
            z.number({
                required_error: MessageErrors.Required,
                invalid_type_error: MessageErrors.Invalid,
            }),
            z.string({
                required_error: MessageErrors.Required,
                invalid_type_error: MessageErrors.Invalid,
            }),
        ]),
        cliente: z.string({
            required_error: MessageErrors.Required,
            invalid_type_error: MessageErrors.Invalid,
        }),
        grupo: z.string({
            required_error: MessageErrors.Required,
            invalid_type_error: MessageErrors.Invalid,
        }),
        repasseMonteBravo: z.number({
            required_error: MessageErrors.Required,
            invalid_type_error: MessageErrors.Invalid,
        }),
        valorMonteBravo: z.number({
            required_error: MessageErrors.Required,
            invalid_type_error: MessageErrors.Invalid,
        }),
        statusPagamentoComissao: z.string({
            required_error: MessageErrors.Required,
            invalid_type_error: MessageErrors.Invalid,
        }),
        dataStatusPagamento: z.date({
            required_error: MessageErrors.Required,
            invalid_type_error: MessageErrors.Invalid,
        }),
        dataDaVenda: z.date({
            required_error: MessageErrors.Required,
            invalid_type_error: MessageErrors.Invalid,
        }),
        mesAnoVenda: z.string({
            required_error: MessageErrors.Required,
            invalid_type_error: MessageErrors.Invalid,
        }),
        anoDaVenda: z.number({
            required_error: MessageErrors.Required,
            invalid_type_error: MessageErrors.Invalid,
        }),
    })
);

export type Commissions = z.infer<typeof commissionsSchema>;
